import React from 'react';
import {NavLink as Link} from 'react-router-dom';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import PublishStatusTableRow from '../table/PublishStatusTableRow.js';
import {Popover, OverlayTrigger} from 'react-bootstrap';

class VariantGroupList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hideArchived: true
    };
  }

  toggleShowArchived() {
    this.setState({
      hideArchived: !this.state.hideArchived
    });
  }

  render() {
    const popoverVarebil = (
      <Popover id="popover-mypage" title="Varebilpriser">
        Varebiler viser kalkulert pris uten mva. dersom reg.avgift er satt på variant.
        Kalkulert pris = (AX-pris - reg.avgift) / 1,25 + reg.avgift.
      </Popover>
    );
    const overlayVarebil = <OverlayTrigger trigger={['hover', 'click', 'focus']} placement="left" overlay={popoverVarebil}>
      <i className="fa fa-question-circle"></i>
    </OverlayTrigger>;

    return (
      <div>
        <div className="pull-right">
          <Link
            to={`/variantgroup/new/${this.props.modelId}`}
            className={`${this.props.modelModified ? 'disabled ' : ''}btn btn-default`}
          >
            <i className="fa fa-plus" aria-hidden="true"></i> Legg til variantgruppe
          </Link>
          &nbsp;
          <Link
            to={`/variant/new/${this.props.modelId}`}
            className={`${this.props.modelModified ? 'disabled ' : ''}btn btn-default`}
          >
            <i className="fa fa-plus" aria-hidden="true"></i> Legg til variant
          </Link>
          &nbsp;
          <button onClick={(e) => {
            e.preventDefault();
            this.toggleShowArchived();
          }} className="btn btn-info" disabled={this.state.working}>
            {this.state.hideArchived ? 'Vis arkiverte' : 'Skjul arkiverte'}
          </button>
        </div>
        <div className="table-responsive clearboth">
          <table className="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th title="Publiseringsstatus"></th>
                <th>Navn</th>
                <th>Visningsnavn</th>

                <th>Type</th>
                <th>År</th>
                <th>Drivstoff</th>
                <th>Utstyrsnivå</th>
                <th>Pris {this.props.modelIsVarebil && overlayVarebil}</th>
                <th>Beskrivelse</th>
              </tr>
            </thead>
            {this.props.variantGroups.map((group) => {
              if (this.state.hideArchived && group.archived) {
                return;
              }

              return (
                <tbody key={group.id}>
                  <PublishStatusTableRow entry={group}>
                    <th className="text-center">
                      <PublishStatusDot entry={group} />
                    </th>
                    <th>
                      <Link to={`/variantgroup/${group.id}`}>{group.name}</Link>
                    </th>
                    <th>{group.displayName}</th>
                    <th colSpan="6">Variantgruppe</th>
                  </PublishStatusTableRow>
                  {this.props.variants.filter((variant) => {
                    return variant.variantGroup && variant.variantGroup.id === group.id;
                  }).map((variant) => {
                    if (this.state.hideArchived && variant.archived) {
                      return;
                    }

                    return <PublishStatusTableRow entry={variant} key={variant.id}>
                      <td className="text-center">
                        <PublishStatusDot entry={variant} />
                      </td>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<Link to={`/variant/${variant.id}`}>{variant.name}</Link></td>
                      <td>{variant.displayName}</td>
                      <td>Variant</td>
                      <td>{variant.year}</td>
                      <td>{variant.fuelType}</td>
                      <td>{variant.equipmentLevel ? <Link to={`/equipmentlevel/${variant.equipmentLevel.id}`}>{variant.equipmentLevel.name}</Link> : '-'}</td>
                      <td>
                        {this.props.modelIsVarebil && !variant.regFee &&
                          <span className="text-warning" title="Mangler reg. avgift">
                            <i className="fa fa-question-circle" aria-hidden="true"></i> &nbsp;
                          </span>
                        }
                        {Intl.NumberFormat('nb-NO', {minimumFractionDigits: 0}).format(variant.price)}
                        {this.props.modelIsVarebil && variant.regFee &&
                          <span className="small" title={`Reg.avgift ${Intl.NumberFormat('nb-NO', {minimumFractionDigits: 0}).format(variant.regFee)}`}> &nbsp; (AX: {Intl.NumberFormat('nb-NO', {minimumFractionDigits: 0}).format(variant.rawPrice)})</span>
                        }
                      </td>
                      <td>{variant.optionDescription}</td>
                    </PublishStatusTableRow>;
                  })}
                </tbody>
              );
            })}

            {this.props.variants.filter((variant) => !variant.variantGroup).length > 0 &&
              <tbody>
                <tr>
                  <th className="text-center">
                  </th>
                  <th>
                    Varianter uten variantgruppe
                  </th>
                  <th></th>
                  <th colSpan="6"></th>
                </tr>
                {this.props.variants.filter((variant) => !variant.variantGroup).map((variant) => {
                  if (this.state.hideArchived && variant.archived) {
                    return;
                  }

                  return <PublishStatusTableRow entry={variant} key={variant.id}>
                    <td className="text-center">
                      <PublishStatusDot entry={variant} />
                    </td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<Link to={`/variant/${variant.id}`}>{variant.name}</Link></td>
                    <td>{variant.displayName}</td>
                    <td>Variant</td>
                    <td>{variant.year}</td>
                    <td>{variant.fuelType}</td>
                    <td>{variant.equipmentLevel ? <Link to={`/equipmentlevel/${variant.equipmentLevel.id}`}>{variant.equipmentLevel.name}</Link> : '-'}</td>
                    <td>
                      {this.props.modelIsVarebil && !variant.regFee &&
                        <span className="text-warning" title="Mangler reg. avgift">
                          <i className="fa fa-circle" aria-hidden="true"></i>
                        </span>
                      }
                      {Intl.NumberFormat('nb-NO', {minimumFractionDigits: 0}).format(variant.price)}
                    </td>
                    <td>{variant.optionDescription}</td>
                  </PublishStatusTableRow>;
                })}
              </tbody>
            }
          </table>
        </div>
      </div>
    );
  }
}

export default VariantGroupList;
